import React from 'react';
import { useNavigate } from 'react-router-dom';

const FeedbackModal = ({ status, message, onClose, onProceedToPayment, mockupImageUrl }) => {
  const navigate = useNavigate();

  const getStatusMessage = () => {
    switch (status) {
      case 'processing':
        return 'Your mockup request is being processed...';
      case 'polling_attempt_1':
        return 'Checking for your mockup... (Attempt 1/4)';
      case 'polling_attempt_2':
        return 'Still working on it... (Attempt 2/4)';
      case 'polling_attempt_3':
        return 'Almost there... (Attempt 3/4)';
      case 'polling_attempt_4':
        return 'Just a little longer... (Attempt 4/4)';
      case 'downloading_image':
        return 'Your mockup is ready! Downloading the image...';
      case 'uploading_to_minio':
        return 'Saving your mockup...';
      case 'completed':
        return 'Your mockup has been successfully generated!';
      case 'failed':
        return 'There was an error generating your mockup. Please try again.';
      case 'timeout':
        return 'This is taking more time than expected. Your mockup will appear on your mockups page once ready.';
      default:
        return message || 'An unknown error occurred.';
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
      <div className="relative mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <button onClick={onClose} className="absolute top-0 right-0 mt-2 mr-2 text-gray-500 hover:text-gray-800">
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <div className="mt-3 text-center">
          <h3 className="text-lg leading-6 font-medium text-gray-900">{getStatusMessage()}</h3>
          <div className="mt-2 px-7 py-3">
            {status === 'completed' && mockupImageUrl && (
              <img src={mockupImageUrl} alt="Generated Mockup" className="w-full h-auto rounded-md shadow-lg mb-4" />
            )}
            <p className="text-sm text-gray-500">{message}</p>
          </div>
          <div className="items-center px-4 py-3">
            {status === 'completed' ? (
              <>
                <button
                  onClick={onProceedToPayment}
                  className="px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
                >
                  Proceed to Payment
                </button>
                <button
                  onClick={onClose}
                  className="mt-2 px-4 py-2 bg-gray-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  Continue Shopping
                </button>
              </>
            ) : status === 'timeout' || status === 'failed' ? (
              <>
                <button
                  onClick={() => navigate('/mockups')}
                  className="px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
                >
                  Go to Mockups
                </button>
                <button
                  onClick={onClose}
                  className="mt-2 px-4 py-2 bg-gray-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  Close
                </button>
              </>
            ) : (
              <button
                onClick={onClose}
                className="px-4 py-2 bg-gray-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
              >
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;